<template>
  <div class="house-type-list-container">
    <!-- 添加拖拽手柄 -->
    <!-- <div class="drag-handle" @touchstart="handleTouchStart" @mousedown="handleMouseDown">
      <div class="drag-handle-icon"></div>
    </div> -->
    <div class="header">
      <h3>选择户型查看分布</h3>
    </div>
    
    <div class="house-type-scroll">
      <!-- 添加点击事件处理 -->
      <div 
        v-for="(type, index) in houseTypes" 
        :key="index" 
        class="house-type-item"
        :style="{ backgroundColor: type.displayColor || getColorForType(index) }"
        @click="handleTypeSelect(type, index)"
      >
       <!-- 添加选中对号 -->
        <div v-if="selectedIndexes.includes(index)" class="selected-check-container" :style="{ backgroundColor: type.displayColor || getColorForType(index) }">
          <div class="selected-check">✓</div>
        </div>
        <!-- 添加图片加载错误处理 -->
        <div class="house-image">
          <img 
            :src="getImageUrl(type.houseTypeImage)" 
            alt="户型图"
          >
        </div>
        <div class="house-info">
          <div class="house-desc">
            {{ type.bedroomCount }}室{{ type.livingRoomCount }}厅{{ type.bathroomCount }}卫 | {{ type.area }}㎡
          </div>
          <div class="house-price">
            约{{ type.minPrice }}~{{ type.maxPrice }}万元
          </div>
          <button 
          class="view-large-btn" 
          @click.stop="handleViewLargeImage(type)"
        >
          查看大图
        </button>
        </div>
      </div>
       <!-- 新增大图预览弹窗 -->
    <a-modal 
      :visible="showLargeImageModal" 
      @ok="showLargeImageModal = false" 
      @cancel="showLargeImageModal = false"
      :footer="null"
       :z-index="1002"
    >
      <img 
        :src="currentLargeImageUrl" 
        alt="户型大图" 
        style="max-width: 100%; max-height: 60vh;"
      >
    </a-modal>
    </div>
  </div>
</template>

<script>
import { HOUSE_IMAGE_API } from '@/config.js';

export default {
  name: 'HouseTypeListComponent',
  props: {
    houseTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      startY: 0,
      startHeight: 0,
      showLargeImageModal: false,  // 新增：控制弹窗显示
      currentLargeImageUrl: '',    // 新增：当前大图URL
      currentType: null,
      selectedIndexes: []
    }
  },
  methods: {
    // 改进颜色生成算法
    getColorForType(index) {
      const hue = (index * 137.508) % 360; 
      // 提高饱和度到 70%，降低亮度到 60% 以获得更鲜艳的颜色
      const saturation = 60; 
      const lightness = 65; 
      const hexColor = this.hslToHex(`hsl(${hue}, ${saturation}%, ${lightness}%)`);
      console.log(hexColor)
      return hexColor;
    },

    hslToHex(hslStr) {
      // 支持带小数的HSL值解析
      const matches = hslStr.match(/hsl\(([\d.]+),\s*([\d.]+)%,\s*([\d.]+)%\)/i);
      if (!matches || matches.length < 4) return '0xffffff';
      
      const h = parseFloat(matches[1]);  // 支持小数色相值
      const s = parseFloat(matches[2]) / 100;
      const l = parseFloat(matches[3]) / 100;

      const a = s * Math.min(l, 1 - l);
      const f = n => {
          const k = (n + h/30) % 12;
          const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
          return Math.round(255 * color).toString(16).padStart(2, '0');
      };
      return `0x${f(0)}${f(8)}${f(4)}`;
    },

    convertHexColorToNumber(colorStr) {
      // 匹配6位十六进制颜色（不区分大小写）
      const hexColorRegex = /^#([0-9A-Fa-f]{6})$/;
      if (hexColorRegex.test(colorStr)) {
        // 去掉开头的 '#'，解析为十六进制整数
        const colorNumber = parseInt(colorStr.slice(1), 16);
        return colorNumber;
      } else {
        console.warn(`"${colorStr}" 不是有效的6位十六进制颜色字符串（例如 #fff705）`);
        return null;
      }
    },

     handleTypeSelect(type, index) {  // 修改：新增index参数
      let selected = true
      // 判断当前索引是否已选中
      if (this.selectedIndexes.includes(index)) {
        // 若已选中则移除
        this.selectedIndexes = this.selectedIndexes.filter(i => i !== index);
        selected = false
      } else {
        // 若未选中则添加
        this.selectedIndexes.push(index);
        selected = true
      }
      // 传递所有选中的户型数据和对应的颜色值
      const typeId = this.houseTypes[index].id
      const color = type.displayColor || this.getColorForType(index);
      const colorNumber = this.convertHexColorToNumber(color);
      this.$emit('type-selected', typeId, colorNumber, selected);
    },
    // 添加拖拽调整高度逻辑
    handleTouchStart(e) {
      this.startY = e.touches[0].clientY;
      this.startHeight = this.$el.offsetHeight;
      document.addEventListener('touchmove', this.handleDrag);
      document.addEventListener('touchend', this.handleDragEnd);
    },
    handleMouseDown(e) {
      this.startY = e.clientY;
      this.startHeight = this.$el.offsetHeight;
      document.addEventListener('mousemove', this.handleDrag);
      document.addEventListener('mouseup', this.handleDragEnd);
    },
    getImageUrl (imageUrl) {
      if (!imageUrl) return ''
      return `${HOUSE_IMAGE_API}/${imageUrl}`
    },
    handleViewLargeImage(type) {
      this.currentLargeImageUrl = this.getImageUrl(type.houseTypeImage);
      this.currentType = type;
      this.showLargeImageModal = true;
    },
    initSelect(houseTypes) {
      console.log(houseTypes)
      houseTypes.forEach((item, index) => {
        this.selectedIndexes.push(index);
        const typeId = item.id
        const color = item.displayColor || this.getColorForType(index);
        const colorNumber = this.convertHexColorToNumber(color);
        this.$emit('type-selected', typeId, colorNumber, true);
      })
    }
  },
  // 添加移除事件监听
  beforeUnmount() {
    document.removeEventListener('mousemove', this.handleDrag);
    document.removeEventListener('mouseup', this.handleDragEnd);
    document.removeEventListener('touchmove', this.handleDrag);
    document.removeEventListener('touchend', this.handleDragEnd);
  }

}
</script>

<style scoped>
.house-type-list-container {
  /* 添加过渡动画 */
  transition: height 0.3s ease;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  /* 调整层级关系 */
  z-index: 1001;
  background-color: #fff;       /* 白色背景 */
  padding-bottom: 20px;
  border-top-left-radius: 26px; 
  border-top-right-radius: 26px; 
}

.header {
  text-align: left;          /* 文字靠左对齐 */
  padding-left: 16px;        /* 添加左侧内边距（可选，根据设计调整） */
  margin-bottom: 8px;        /* 可选：增加与下方内容的间距 */
}

/* 新增拖拽手柄样式 */
.drag-handle {
  padding: 8px 0;
  display: flex;
  justify-content: center;
  cursor: ns-resize;
}
.drag-handle-icon {
  width: 40px;
  height: 4px;
  background: #ddd;
  border-radius: 2px;
}

.house-type-scroll {
  /* 优化移动端滚动 */
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  /* 新增横向滚动关键样式 */
  display: flex;          /* 启用弹性布局 */
  overflow-x: auto;       /* 横向滚动 */
  overflow-y: hidden;     /* 隐藏竖向滚动 */
   /* 新增：设置户型项间距 */
  gap: 16px;  /* 可根据需求调整数值 */
  padding: 0 16px; 
}
.house-type-scroll::-webkit-scrollbar {
  display: none;
}

.house-type-item {
  /* 优化移动端点击效果 */
  transition: transform 0.2s;
  min-width: 120px;
  max-width: 140px;
  flex-shrink: 0;
   /* 新增：添加阴影和圆角提升质感 */
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 12px;
  position: relative;
}
.house-type-item:active {
  transform: scale(0.98);
}

.house-desc {
  text-align: left; /* 文字靠左对齐 */
  color: white; /* 文字颜色设为白色 */
  font-weight: bold; /* 文字加粗 */
  font-size: 16px;
}

.house-price {
  text-align: left; /* 文字靠左对齐 */
  color: white; /* 文字颜色设为白色 */
  font-size: 15px;
}

.selected-check-container {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 新增白色对号样式 */
.selected-check {
  color: #ffffff;    /* 白色对号 */
  font-weight: bold; /* 加粗 */
  font-size: 18px;   /* 适当放大 */
  z-index: 2;        /* 确保覆盖图片（图片默认z-index为0） */
  text-shadow: 0 0 4px rgba(0,0,0,0.3);  /* 可选：添加阴影增强对比度 */
}

.house-image {
aspect-ratio: 4/3;
  width: 100%; /* 图片容器占满户型项宽度 */
   /* 新增：设置颜色框内边距 */
  border-radius: 8px;  /* 与图片圆角保持一致 */
  box-sizing: border-box;
}

.house-image img {
  /* 保持图片比例 */
  aspect-ratio: 4/3;
  /* 新增尺寸控制 */
  width: 100%;        /* 图片宽度占满容器 */
  height: auto;       /* 自动计算高度保持比例 */
  object-fit: cover;  /* 覆盖容器避免变形 */
  /* 可选：添加最大高度限制（根据实际需求调整） */
  max-height: 120px;  
  border-radius: 4px;
}

.view-large-btn {
  width: 80%;
  margin: 8px auto 12px;
  padding: 6px 8px;  /* 调整内边距增加高度 */
  border: none;
  border-radius: 16px;  /* 大圆角 */
  background-color: #fff;  /* 白色背景 */
  color: #333;  /* 深色文字 */
  font-size: 15px;
  cursor: pointer;
  transition: opacity 0.2s;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);  /* 可选：添加阴影提升质感 */
}
.view-large-btn:hover {
  opacity: 0.9;
  background-color: #f5f5f5;  /* 悬停微变色 */
}

</style>